// Add all global js functions to this file
// global recordEvent
function recordEvent(event_name, value_name, value) {
  let csrfToken = $('meta[name="csrf-token"]').attr('content');
  jQuery.ajax({
    type: "POST",
     beforeSend: function(xhr) {
       xhr.setRequestHeader('X-CSRF-Token', csrfToken);
     },
    url: "/__record_event",
    data: "event_name=" + event_name + "&value_name=" + value_name + "&value=" + value
  });
}
window.recordEvent = recordEvent;


// launch job clickout
function launch_job_clickout(url, id) {
  var params = 'top=0, left=0';
  params += ', directories=no';
  params += ', location=yes';
  params += ', menubar=yes';
  params += ', resizable=yes';
  params += ', scrollbars=yes';
  params += ', status=yes';
  params += ', toolbar=no';
  params += ', width=1000';
  params += ', height=700';

  window.open(url, '_blank', params);

  return false;
}
window.launch_job_clickout = launch_job_clickout;


// scroll to anchor
function scrollToAnchor(anchor) {
  if (anchor !== null && typeof(anchor) !== 'undefined' && anchor !== '') {
    let target = document.getElementById(anchor);
    if (target !== null && typeof(target) !== 'undefined' && target !== '') {
      target.scrollIntoView({
          behavior: 'smooth'
      });
    }
  }
}
window.scrollToAnchor = scrollToAnchor;

// Function to replace a class on a DOM element.
// Takes the element ID, class to remove, and class to add.
function toggleClass(id, add, remove) {
  var element = document.getElementById(id);
  element.classList.add(add);
  element.classList.remove(remove);
}
window.toggleClass = toggleClass;
